import Store from '@/store'
import { getToken } from '@/services/utils/index'
import { isString } from 'xe-utils'
import { isObject } from 'lodash'

export function isNullOrUndefined(val) {
  return val === null || val === undefined
}

export function formatNullOrUndefined(val, defaultVal = '') {
  return isNullOrUndefined(val) ? defaultVal : val
}

// 获取url对象
export function getUrlData(url = window.location.search) {
  url = url.split('?')[1]// 去掉?剩下的都为a=b&c=d&e=f...模式
  const dataObj = {}
  if (url.indexOf('&') > -1) {
    url = url.split('&')// url中去掉&全部变成“a=b” “c=d” “e=f”的模式
    for (let i = 0; i < url.length; i++) {
      const arr = url[i].split('=')
      dataObj[arr[0]] = arr[1]
    }
  } else {
    url = url.split('=')
    dataObj[url[0]] = url[1]
  }
  return dataObj
}

const commaStrToArr = (val) => {
  if (isString(val) && val.indexOf(',') !== -1) {
    return val.split(',')
  }

  return val
}

// 获取url对象, 处理逗号为一个数组
export function getUrlDataCommaStrToArr(url = window.location.search) {
  url = url.split('?')[1]// 去掉?剩下的都为a=b&c=d&e=f...模式
  const dataObj = {}
  if (url.indexOf('&') > -1) {
    url = url.split('&')// url中去掉&全部变成“a=b” “c=d” “e=f”的模式
    for (let i = 0; i < url.length; i++) {
      const arr = url[i].split('=')
      dataObj[arr[0]] = commaStrToArr(arr[1])
    }
  } else {
    url = url.split('=')
    dataObj[url[0]] = commaStrToArr(url[1])
  }
  return dataObj
}

// 下载url转换数组
export function transitionDownUrl(val) {
  const commonMap = Store.state.map.commonMap
  const urlQuery = getUrlData(val)
  if (urlQuery.shopId) {
    urlQuery.shopIdList = urlQuery.shopId
    delete urlQuery.shopId
  } else if (urlQuery.shopIds) {
    urlQuery.shopIdList = urlQuery.shopIds
  } else if (!urlQuery.shopIdList) {
    urlQuery.shopIdList = commonMap.map(item => item.shopId).join(',')
  }
  if (urlQuery.countryCode) {
    urlQuery.countryCodeList = urlQuery.countryCode
  } else if (urlQuery.countryCodes) {
    urlQuery.countryCodeList = urlQuery.countryCodes
  } else if (!urlQuery.countryCodeList) {
    urlQuery.countryCodeList = [...new Set(commonMap.map(item => item.countryCode))].join(',')
  }
  let newUrlQuery = []
  Object.keys(urlQuery).forEach(key => {
    newUrlQuery.push(`${key}=${urlQuery[key]}`)
  })
  newUrlQuery = newUrlQuery.join('&')
  return val.split('?')[0] + '?' + newUrlQuery
}

export function transitionDownUrlObj(reqData) {
  const ret = { ...reqData }
  const commonMap = Store.state.map.commonMap

  if (ret.shopId) {
    ret.shopIdList = ret.shopId
  } else if (ret.shopIds) {
    ret.shopIdList = ret.shopIds
  } else if (!ret.shopIdList) {
    ret.shopIdList = commonMap.map(item => item.shopId).join(',')
  }

  if (ret.countryCode) {
    ret.countryCodeList = ret.countryCode
  } else if (ret.countryCodes) {
    ret.countryCodeList = ret.countryCodes
  } else if (!ret.countryCodeList) {
    ret.countryCodeList = [...new Set(commonMap.map(item => item.countryCode))].join(',')
  }

  return ret
}

/**
 * 生成直接连接服务器的下载链接
 * @param {} url
 * @param {*} reqData
 * @returns
 */
export function genDirectiveDownloadUrl(url, reqData = {}, delNullAndUndefined = false) {
  const token = getToken().token
  reqData.token = token

  const qsArr = []
  Object.entries(reqData).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      qsArr.push(`${key}=${value.join(',')}`)
    } else {
      if (delNullAndUndefined && (value === null || value === undefined)) {
        // 跳出本次 forEach
        return
      }

      qsArr.push(`${key}=${value}`)
    }
  })

  const originUrl = `${url}?${qsArr.join('&')}`
  const parsedUrl = transitionDownUrl(originUrl)
  return parsedUrl
}

export function isNullOrUndefinedOrEmptyStr(val) {
  return isNullOrUndefined(val) || val === ''
}

/**
 * 查找枚举中的某个item
 * @param {*} enumObj
 * @param {*} value
 * @returns
 */
export function enumFindItem(enumObj, value) {
  return Object.values(enumObj || {}).find(item => item.value === value) || {}
}

/**
 * enum替换成select 数组
 * @param {*} enumObj
 * @returns
 */
export function enumToOptions(enumObj, filters) {
  let entries = Object.values(enumObj || {})
  if (filters) {
    entries = Object.values(enumObj || {}).filter(item => {
      let ret = true
      Object.entries(filters).forEach(([filterKey, filterValue]) => {
        if (item[filterKey] !== filterValue) {
          ret = false // modify global var
          return false // 跳出forEach
        }
      })

      return ret
    })
  }

  return entries.map(item => {
    return {
      ...item,
      id: item.value,
      name: item.label,
    }
  })
}

export function enumItemListToOptions(enumItemList) {
  return (enumItemList || []).map(item => {
    return {
      ...item,
      id: item.value,
      name: item.label,
    }
  })
}

// 对象数组去重
export function uniqueFunc(arr, uniId) {
  const hash = {}
  return arr.reduce((accum, item) => {
    // eslint-disable-next-line no-unused-expressions
    hash[item[uniId]] ? '' : hash[item[uniId]] = true && accum.push(item)
    return accum
  }, [])
}

export function getEstimatedWidthOfDomSpan(text, options = {}) {
  const defaultOptions = {
    font: '12pt arial',
    fontSize: '12px',
    fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
  }

  const finalOptions = {
    ...defaultOptions,
    ...options,
  }

  if (!getEstimatedWidthOfDomSpan.canvasIns) {
    getEstimatedWidthOfDomSpan.canvasIns = document.createElement('canvas')
  }

  const canvas = getEstimatedWidthOfDomSpan.canvasIns
  const context = canvas.getContext('2d')
  context.font = `${finalOptions.fontSize} ${finalOptions.fontFamily}`

  const {
    width
  } = context.measureText(text)

  return width
}

/**
 * 表格数据里面深层结构打平
 * @param {*} dataList
 * @param {*} keys
 */
export function flatTableDataList(dataList = [], keys = []) {
  dataList.forEach(item => {
    keys.forEach(key => {
      if (isObject(item[key])) {
        const propertyObj = item[key]
        Object.entries(propertyObj).forEach(([propertyObjKey, propertyObjValue]) => {
          const flatKey = `fe-flat__${key}__${propertyObjKey}`
          item[flatKey] = propertyObjValue
        })
      }
    })
  })
}

export function percentageToDecimals(val) {
  if (String(val).indexOf('%') === -1) {
    return 0
  }

  const numPart = Number(String(val).slice(0, -1))
  return Number(Number(numPart / 100).toFixed(2))
}

export function decimalsToPercentage(val) {
  return (Number(val) * 100).toFixed(2) + '%'
}

// hex -> rgba
export function hexToRgba(hex, opacity) {
  return 'rgba(' + parseInt('0x' + hex.slice(1, 3)) + ',' + parseInt('0x' + hex.slice(3, 5)) + ',' +
          parseInt('0x' + hex.slice(5, 7)) + ',' + opacity + ')'
}
